import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateSuspendedPlayerModal } from '~/components/account/ducks';
import { OPERATION_TYPES } from '~/components/payment/suspended-players-modal/constants';

// Define the props interface for better type safety
interface SuspendedModalProps {
	operationType: typeof OPERATION_TYPES.DEPOSIT | typeof OPERATION_TYPES.WITHDRAW | typeof OPERATION_TYPES.NONE;
	isDepositBlocked?: boolean;
	isWithdrawBlocked?: boolean;
	[key: string]: unknown;
}

export const useSuspendedPlayerModal = () => {
	const dispatch = useDispatch();

	const showSuspendedModal = useCallback(
		(props: SuspendedModalProps) => {
			dispatch(
				updateSuspendedPlayerModal(true, {
					...props
				})
			);
		},
		[dispatch]
	);

	const hideSuspendedModal = useCallback(() => {
		dispatch(updateSuspendedPlayerModal(false));
	}, [dispatch]);

	return {
		showSuspendedModal,
		hideSuspendedModal
	};
};
